import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_NODE_BACKEND}/v1`,
});

export default api;
